import { COMPANY } from "@/data/company";
import { MapPin, ExternalLink } from "lucide-react";

const Badge = ({ href, testId, title, subtitle }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className="group flex items-center gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2 hover:border-magenta transition-colors"
  >
    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-[#1D4ED8] font-display text-[11px] font-extrabold text-white">
      ANPC
    </span>
    <span className="leading-tight">
      <span className="block text-xs font-bold text-slate-900 group-hover:text-magenta transition-colors">
        {title}
      </span>
      <span className="block text-[11px] text-slate-500">{subtitle}</span>
    </span>
    <ExternalLink size={13} className="ml-auto text-slate-400" />
  </a>
);

export const FooterCompanyInfo = () => (
  <div data-testid="footer-company-info" className="mt-6 text-sm text-slate-500 leading-relaxed">
    <div className="font-semibold text-slate-700">{COMPANY.legalName}</div>
    <div>
      CUI: {COMPANY.cui} · Nr. Reg. Com.: {COMPANY.regCom}
    </div>
    <div className="flex items-start gap-1.5 mt-1">
      <MapPin size={14} className="mt-0.5 shrink-0 text-magenta" />
      <span data-testid="footer-address">
        {COMPANY.address}, {COMPANY.city}, {COMPANY.country}
      </span>
    </div>
  </div>
);

export const FooterAnpc = () => (
  <div data-testid="footer-anpc" className="mt-6">
    <p className="text-xs text-slate-500 mb-3">
      Soluționarea alternativă și online a litigiilor
    </p>
    <div className="grid sm:grid-cols-2 gap-3 max-w-md">
      <Badge
        href="https://anpc.ro/ce-este-sal/"
        testId="footer-anpc-sal"
        title="ANPC – SAL"
        subtitle="Soluționarea alternativă a litigiilor"
      />
      <Badge
        href="https://ec.europa.eu/consumers/odr"
        testId="footer-anpc-sol"
        title="SOL – ODR"
        subtitle="Soluționarea online a litigiilor (UE)"
      />
    </div>
  </div>
);
